export const WorkData = [
    {
        company: "Enset MOHAMMEDIA" ,
        designation: "Software Engineer Student",
        dateJoining: "2021",
        dateEnd: "Current",
        companyLogo:require("../../assets/icons/LOGO-FR-ENSET-3.png"),
        work:"Engineering student in software engineering and distributed computer systems at ENSET MOHAMMEDIA"
    },
    {
        company: "EST CASABLANCA" ,
        designation: "Bachelor Degree",
        dateJoining: "2020",
        dateEnd: "2021",
        companyLogo:require("../../assets/icons/EST.png"),
        work:"Lp in software engineering and advanced administration of computer systems and networks at EST CASABLANCA"
    },
    {
        company: "Ens TETOUAN" ,
        designation: "Technical University degree",
        dateJoining: "2018",
        dateEnd: "2020",
        companyLogo:require("../../assets/icons/ENS.jpg"),
        work:"Technical University degree multimedia and web design at the Ens TETOUAN"
    },
    {
        company: "Mansour Eddahbi M'DIC High School" ,
        designation: "Baccalaureate",
        dateJoining: "2017",
        dateEnd: "2018",
        companyLogo:"https://cdn-icons-png.flaticon.com/512/2537/2537415.png",
        work:" International Baccalaureate Mathematical Sciences A, French option.  Mansour Eddahbi M'DIC High School"
    }
]